import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { api, useAPIContext } from '../../../../api/context';
import toast from '../../../../utils/toast';
import { Title } from '../../../../utils/title';
import Icon from '../../../../components/Icon';
import socials from '../../../../utils/socials';
import Layout from '../Layout';
import styles from './Socials.module.scss';

const Socials = () => {

  const [ loading, setLoading ] = useState(true);
  const [ items, setItems ] = useState();

  const { token } = useAPIContext();

  const handle = (data) => {
    setItems(
      [
        'tiktok',
      ]
      .map(key => {
        const item = data[key] || {};
        item._key = key;
        return item;
      })
    );
  };

  useEffect(() => {

    handle({});

    api(token).v1.socials.query()
      .then(res => {
        if (res.status === 200) {
          setLoading(false);
          handle(res.body.data);
        }
      })
      .catch(err => {
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token]);

  const connect = (key) => {

    setLoading(true);

    api(token).v1.socials
      .post(
        { provider: key },
        { target: window.location.href },
      )
      .then(res => {
        if (res.status === 200) {
          window.location.href = res.body.url;
        } else {
          setLoading(false);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  };

  const disconnect = (key) => {

    setLoading(true);

    api(token).v1.socials
      .remove({ provider: key })
      .then(res => {
        setLoading(false);
        if (res.status === 200) {
          handle(res.body.data);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  };

  return (
    <>
      <Title value='Social Networks - Profile' />
      <Layout>
        <div className={styles.root}>
          <div className={styles.content}>
            <div className={styles.header}>
              <Link
                to='/profile'
                aria-label='go back'>

                <Icon name={'arrow_back'} />

              </Link>

              <h1>Social Networks</h1>
            </div>

            <div className={`${styles.items} ${loading ? styles.loading : ''}`}>
              {
                items && items.map(item => (
                  <div key={item._key}>
                    <div className={styles.image}>
                      <LazyLoadImage
                        alt={socials.ITEM[item._key].label}
                        src={socials.ITEM[item._key].image}
                      />
                    </div>

                    <div className={styles.info}>
                      <div className={styles.label}>
                        {socials.ITEM[item._key].label}
                      </div>

                      {
                        item.uid &&
                        item.exp &&
                        item.exp.text && (
                          <div>
                            {item.exp.secs > 0 && 'Expires'}
                            {item.exp.secs < 0 && 'Expired'}
                            {' '}

                            {item.exp.text}
                          </div>
                        )
                      }
                    </div>

                    <div className={styles.actions}>
                      {
                        !loading &&
                        !item.uid && (
                          <button
                            className={styles.connect}
                            disabled={loading}
                            aria-label={`connect ${item._key}`}
                            onClick={() => connect(item._key)}>

                            Connect

                          </button>
                        )
                      }

                      {
                        item.uid &&
                        item.exp &&
                        item.exp.secs > 0 && (
                          <button
                            className={styles.disconnect}
                            disabled={loading}
                            aria-label={`disconnect ${item._key}`}
                            onClick={() => disconnect(item._key)}>

                            Disconnect

                          </button>
                        )
                      }

                      {
                        item.uid &&
                        item.exp &&
                        item.exp.secs < 0 && (
                          <button
                            className={styles.reconnect}
                            disabled={loading}
                            aria-label={`reconnect ${item._key}`}
                            onClick={() => connect(item._key)}>

                            Reconnect

                          </button>
                        )
                      }
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Socials;